import { ExternalProvider } from '@ethersproject/providers'
import { BAD_SRCS } from 'components/Logo/Logo'
import {
  CHAIN_CONFIG,
  GRX_CHAIN_ID,
  SupportedChainId,
  isSupportedChainId,
} from 'config/constants/chains'

export const setupNetwork = async (
  targetChainId: number = GRX_CHAIN_ID,
  externalProvider?: ExternalProvider,
): Promise<boolean> => {
  const provider = externalProvider || window.ethereum

  if (!isSupportedChainId(targetChainId)) {
    console.error('Unsupported chain ID:', targetChainId)
    return false
  }

  const chainId = targetChainId as SupportedChainId
  const networkConfig = CHAIN_CONFIG[chainId]

  if (!provider) {
    console.error('Cannot configure network because no wallet provider is available')
    return false
  }

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: `0x${chainId.toString(16)}` }],
    })

    return true
  } catch (switchError) {
    if ((switchError as any)?.code !== 4902) {
      console.error('Failed to switch network:', switchError)
      return false
    }
  }

  try {
    const networkParameters: Record<string, unknown> = {
      chainId: `0x${chainId.toString(16)}`,
      chainName: networkConfig.chainName,
      nativeCurrency: networkConfig.nativeCurrency,
      rpcUrls: [...networkConfig.rpcUrls],
    }

    if (networkConfig.explorerUrls.length > 0) {
      networkParameters.blockExplorerUrls = [...networkConfig.explorerUrls]
    }

    await provider.request({
      method: 'wallet_addEthereumChain',
      params: [networkParameters],
    })

    return true
  } catch (addError) {
    console.error('Failed to add network:', addError)
    return false
  }
}

export const registerToken = async (
  tokenAddress: string,
  tokenSymbol: string,
  tokenDecimals: number,
  tokenLogo?: string,
) => {
  const image = tokenLogo ? (BAD_SRCS[tokenLogo] ? undefined : tokenLogo) : undefined

  return window.ethereum.request({
    method: 'wallet_watchAsset',
    params: {
      type: 'ERC20',
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image,
      },
    },
  })
}
